import { Message } from '@gonfalon/messages/Message';
import { msg } from '@gonfalon/messages/msg';
import { Code } from '@launchpad-ui/components';
import clsx from 'clsx';

import styles from './AnalyzedByTag.module.css';

export type AnalyzedByTagAppearance = 'primary' | 'tertiary';

export function AnalyzedByTag({
  analysisUnit,
  appearance = 'primary',
  className,
}: {
  analysisUnit: string;
  appearance?: AnalyzedByTagAppearance;
  className?: string;
}) {
  const label = msg('experiments.resultsAnalyzedBy.tagLabel', { unit: analysisUnit });
  return (
    <span
      className={clsx(styles.analyzedByTag, appearance === 'tertiary' ? styles.tertiary : styles.primary, className)}
      title={label}
      aria-label={label}
    >
      <span className={styles.label}>
        <Message id="experiments.resultsAnalyzedBy.label" />
      </span>
      <Code size="small" className={styles.unit}>
        {analysisUnit}
      </Code>
    </span>
  );
}
